module.exports = __webpack_public_path__ + "img/securitydetailsList5.a846b05d.png";